import { Heading, P, Text, Ul } from '@slal/ui/typography';
import { useCallback, useState } from 'react';
import { DeclarationModal } from '../application';
import {
    DocumentListItem,
    ProductInformationArticle,
    ProductRequirementsHeading,
    StyledCheckCircleIcon,
    StyledLink,
    StyledListItem,
    StyledProductBenefits,
} from './styles';

export const ProductInformation = () => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const closeModal = useCallback(() => setIsModalOpen(false), [setIsModalOpen]);
    const openModal = useCallback(() => setIsModalOpen(true), [setIsModalOpen]);

    const id = 'product--information';
    return (
        <ProductInformationArticle aria-labelledby={id}>
            <Heading level={1} id={id}>
                Flexible access to your pension savings
            </Heading>
            <P>
                To start taking your money, you can transfer your ReAssure pension into a Standard Life Active Money
                Personal Pension.
            </P>
            <P>
                To do this, you can complete our simple application. This will start the transfer process and you'll be
                able to request your first withdrawal. You can then access your pension as and when you need.
            </P>
            <Heading level={1}>Why Standard Life</Heading>
            <StyledProductBenefits>
                <StyledListItem>
                    <Text tag="span">
                        <StyledCheckCircleIcon />
                    </Text>
                    <P>A 5-star pension with easy online access</P>
                </StyledListItem>
                <StyledListItem>
                    <Text tag="span">
                        <StyledCheckCircleIcon />
                    </Text>
                    <P>A simple application, allowing your money to remain in the same group.*</P>
                </StyledListItem>
                <StyledListItem>
                    <Text tag="span">
                        <StyledCheckCircleIcon />
                    </Text>
                    <P>Qualified pension experts based in the UK and ready to help you through the transfer process</P>
                </StyledListItem>
            </StyledProductBenefits>
            <P markdown>
                See [frequently asked questions](https://www.standardlife.co.uk/learnmore) about accessing your money
                with Standard Life.
            </P>
            <P>*ReAssure is part of Standard Life.</P>
            <ProductRequirementsHeading level={3}>You'll need your:</ProductRequirementsHeading>
            <Ul>
                <DocumentListItem>
                    ReAssure policy number and current value, shown on any statement or letters
                </DocumentListItem>
                <DocumentListItem>National Insurance number</DocumentListItem>
                <DocumentListItem>Bank details</DocumentListItem>
            </Ul>
            <br />
            <P>You must be a UK resident to apply.</P>
            <Heading level={1}>Key things to consider</Heading>
            <Heading level={5}>Money left in your pension remains invested:</Heading>
            <P>
                You need to make sure your investments remain right for you. Remember the value can go down as well as
                up and you could get back less.
            </P>
            <Heading level={5}>Your money could run out:</Heading>
            <P>
                How much you take, when you take it and how your investments perform will affect how long your pension
                pot will last.
            </P>
            <Heading level={5}>Transferring is not right for everyone:</Heading>
            <P>
                Check if there are any <Text tag="strong">exit charges</Text>
                {', '}
                <StyledLink type="button" onClick={openModal}>
                    valuable features and guarantees
                </StyledLink>{' '}
                you might be giving up.
            </P>
            <P>Throughout this application process we highlight other important things you need to consider.</P>
            <DeclarationModal isOpen={isModalOpen} onClose={closeModal} />
        </ProductInformationArticle>
    );
};
